module.exports = __webpack_public_path__ + "./Billy_color_4217b07e0b37d76f392aa094db7c07f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2024/Billy_color.jpg
// module id = 612
// module chunks = 0